<div class="perfil" *ngIf="user; else loading">
  <!-- Banner del usuario -->
  <div class="banner" [style.backgroundImage]="'url(' + (user.imgBanner || '/obras/paleta/portada.png') + ')'"></div>

  <!-- Contenido del perfil -->
  <div class="contenido">
    <!-- Imagen de perfil -->
    <img
      class="avatar"
      [src]="user.imgPerfil ? user.imgPerfil : '/obras/paleta/tres.png'"
      alt="Avatar"
    >

    <!-- Información del usuario -->
    <div class="info">
      <span class="nombre">{{ user.username || 'Usuario desconocido' }}</span>
      <p class="usuario">{{ user.username }} · {{ user.role || 'Sin rol' }}</p>
      <p class="descripcion">
        {{ user.nacionalidad || 'Nacionalidad no especificada' }}
      </p>

      <!-- Redes sociales -->
      <a *ngIf="user.twitter" [href]="user.twitter" target="_blank" class="enlace">
        Twitter
      </a>
      <a *ngIf="user.facebook" [href]="user.facebook" target="_blank" class="enlace">
        Facebook
      </a>
      <a *ngIf="user.instagram" [href]="user.instagram" target="_blank" class="enlace">
        Instagram
      </a>

      <!-- Botón de acción -->
      <div class="acciones">
        <button class="boton">Suscribirse</button>
        <button class="botonEditar" (click)="navigateToEditProfile()">Editar Perfil</button>
      </div>
    </div>
  </div>

  <!-- Menú de navegación -->
  <nav class="menu">
    <a href="" class="activo">Nuevos!</a>
    <a href="">Obras</a>
    <a href="">Siguiendo</a>
    <a href="">Mi Feed</a>
    <a href="">Mis Likes</a>
    <a href="">Publicaciones</a>
    <a href="">Membresía</a>
  </nav>

  <!-- Lista de mangas -->
  <app-manga-list [mangas]="mangas"></app-manga-list>
</div>

<!-- Mensaje de carga -->
<ng-template #loading>
  <div class="loading">
    <p>Cargando información del usuario...</p>
  </div>
</ng-template>


